import React from 'react';
import { Tabs } from 'antd';
import FeedbackPage from './FeedbackPage';
import FeedbackTemplate from './FeedbackTemplate';
import QuestionPage from './QuestionPage';
import Archive from './Archive';

const { TabPane } = Tabs;

const Feedback = () => {
  return (
    <Tabs defaultActiveKey="1" type="card" size="middle">
      <TabPane tab="Feedback" key="1">
        <FeedbackPage />
      </TabPane>
      <TabPane tab="Templates" key="2">
        <FeedbackTemplate feedbackStatus="active" />
      </TabPane>
      <TabPane tab="Questions" key="3">
        <QuestionPage questionStatus="active" />
      </TabPane>
      <TabPane tab="Archived" key="4">
        <Archive />
      </TabPane>
    </Tabs>
  );
};

export default Feedback;
